import React, { Component } from 'react';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { observer, inject } from 'mobx-react';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
    root: {
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        width: 400,
    },
    iconButton: {
        padding: 10,
    },
    divider: {
        height: 28,
        margin: 4,
    },
    input: {
        marginLeft:5,
        flex: 1,
    },
});


const randomWords = ['wound',
    'passenger',
    'terrific',
    'paper',
    'stamp',
    'flung',
    'peace',
    'determined',
    'aftermath',
    'border',
    'fabulous',
    'unequal'];

@inject( 'wcpStore' )
@observer
class ChooseWordDialog extends Component  {

    constructor(props) {
        super(props);

        this.state = {
            wordValue: ''
        }
    }

    randomWord = () => {
        const newWord = randomWords[Math.floor(Math.random() * randomWords.length)].toUpperCase();
        this.setState({
            wordValue: this.props.wcpStore.cleanWord(newWord)
        });
    }

    handleInputChange = (e) => {
        this.setState({
            wordValue: e.target.value
        });
    }

    handleClose = () => {
        this.setState({
            wordValue: ''
        });
        this.props.onClose();
    }

    handleOk = () => {
        this.props.wcpStore.addWord(this.state.wordValue);
        this.handleClose();
    }

    render() {
        const { open, classes } = this.props;

        return (
            <Dialog onClose={this.handleClose} aria-labelledby="simple-dialog-title" open={open}>
                <DialogTitle id="simple-dialog-title">Pick a word</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Please type in a word or select a random word from our library!
                        <Button className={classes.iconButton} onClick={this.randomWord}>
                             Random Word
                        </Button>
                    </DialogContentText>

                    <Paper className={classes.root}>
                        <InputBase
                            className={classes.input}
                            placeholder="Type word..."
                            value={this.state.wordValue} onChange={this.handleInputChange}/>
                    </Paper>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose} color="primary">
                        Cancel
                    </Button>

                    <Button onClick={this.handleOk} color="primary" autoFocus>
                        OK
                    </Button>
                    </DialogActions>
            </Dialog>
        );
    }
}

export default withStyles(styles)(ChooseWordDialog);